import axios from 'axios';

// Configuration de l'URL de base de votre API
const baseURL = 'https://pay-api.dibasolutions.com/api/gateway/v1/'; 
//const baseURL = 'https://899c-41-202-219-77.ngrok-free.app/api/gateway/v1/'; 

const httpService = axios.create({
    baseURL,
    // Timeout: 10000, // Temps d'attente maximal en millisecondes
});

// Interceptor pour ajouter le token à chaque requête
httpService.interceptors.request.use(
    config => {
        const token = localStorage.getItem('authToken');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// Fonction pour effectuer une requête GET
export const get = (url: any, params = {}) => {
    return httpService.get(url, { params });
};

// Fonction pour effectuer une requête POST
export const post = (url:any, data:any) => {
    return httpService.post(url, data);
};

// Fonction pour effectuer une requête PUT
export const put = (url:any, data:any) => {
    return httpService.put(url, data);
};

// Exportez le service HTTP
export default httpService;
